import routes from "@/routes/routes";

import { TKnownError } from "./types";

/**
 * Creates a normalized `TKnownError` with safe defaults and guardrails.
 *
 * This factory centralizes error intent so that:
 * - Known errors have consistent shape across the app
 * - Silent errors never get "lost" unintentionally
 * - Global side-effects (toast / redirect) behave predictably
 *
 * @param partial - Partial error definition.
 *                  Must include `code` and `message`.
 * @returns {TKnownError} A fully normalized `TKnownError` instance.
 */
export function createKnownError(
  partial: Partial<TKnownError> & Pick<TKnownError, 'code' | 'message'>
): TKnownError {
  const silent = partial.silent ?? false;
  const delegateToClient = partial.delegateToClient ?? false;

  return {
    silent,
    delegateToClient,
    ...partial,
    redirectTo:
      silent && !delegateToClient && !partial.redirectTo
        ? routes.error
        : partial.redirectTo,
  };
};

